import './package-content.scss'

export const component = {
    name: 'package-content',

    data: {
        contactFormState: 'hide',
        bookingUrl: null
    },

    mounted () {
        console.log(this.urls)
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/package-content/package-content.js